var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "left" }, [
        !_vm.editPlayDayState
          ? _c("div", [
              _vm.chenckBudget.departureDate
                ? _c(
                    "b",
                    {
                      staticClass: "hiddenText",
                      staticStyle: { width: "1.2rem" },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.dateFormatYMD(
                              _vm.chenckBudget.departureDate,
                              "-"
                            )
                          ) +
                          " 出发 "
                      ),
                    ]
                  )
                : _c(
                    "b",
                    {
                      staticClass: "hiddenText",
                      staticStyle: { width: "1.2rem" },
                    },
                    [_vm._v("暂无出发日期")]
                  ),
              _c("span", { staticClass: "daybox" }, [
                _vm._v(_vm._s(_vm.chenckBudget.planDay) + "天"),
              ]),
              _c(
                "a",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showShaft == 1,
                      expression: "showShaft==1",
                    },
                  ],
                  on: { click: _vm.changePlanDayAndStartDate },
                },
                [_vm._v("更改天数")]
              ),
            ])
          : _c(
              "div",
              [
                _c(
                  "span",
                  { staticClass: "dateBox" },
                  [
                    _c("el-date-picker", {
                      staticStyle: { width: "1.1rem" },
                      attrs: {
                        size: "mini",
                        type: "date",
                        clearable: false,
                        placeholder: "选择日期",
                        "value-format": "yyyy-MM-dd",
                      },
                      model: {
                        value: _vm.departureDate,
                        callback: function ($$v) {
                          _vm.departureDate = $$v
                        },
                        expression: "departureDate",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "0.6rem" },
                    attrs: { size: "mini", placeholder: "" },
                    model: {
                      value: _vm.playDayNumber,
                      callback: function ($$v) {
                        _vm.playDayNumber = $$v
                      },
                      expression: "playDayNumber",
                    },
                  },
                  _vm._l(60, function (i) {
                    return _c("el-option", {
                      key: i,
                      attrs: { label: i, value: i },
                    })
                  }),
                  1
                ),
                _c(
                  "a",
                  {
                    on: {
                      click: function ($event) {
                        _vm.editPlayDayState = false
                      },
                    },
                  },
                  [_vm._v("取消")]
                ),
                _c("a", { on: { click: _vm.saveChangePlanDays } }, [
                  _vm._v("保存"),
                ]),
              ],
              1
            ),
        _c(
          "div",
          { staticClass: "leftChild" },
          _vm._l(_vm.chenckBudget.planDayList, function (item, index) {
            return _c(
              "div",
              {
                key: index,
                style:
                  item.planDay == _vm.checkPlanDay
                    ? "background: rgb(220, 220, 220);"
                    : "",
                attrs: { id: "planDay" + item.planDay },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.changePlanDay(item)
                  },
                },
              },
              [
                _c("div", { staticClass: "planDay" }, [
                  _vm._v("D" + _vm._s(item.planDay)),
                ]),
                _c("div", { staticClass: "citycenter" }, [
                  _c("p", [
                    _vm._v(
                      " " +
                        _vm._s(
                          item.planDate
                            ? _vm.dateFormatYMD(
                                new Date(item.planDate).getTime(),
                                "-"
                              )
                            : "暂无出发日期"
                        ) +
                        " " +
                        _vm._s(_vm.getWeekDate(item.planDate)) +
                        " "
                    ),
                  ]),
                  item.cityList.length > 0
                    ? _c(
                        "div",
                        { staticStyle: { margin: "0.13rem 0.15rem 0px 0px" } },
                        [
                          _vm._l(item.cityList, function (i, ind) {
                            return [
                              _c(
                                "span",
                                {
                                  key: ind,
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.changePlanDay(item, i)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "el-popover",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.showShaft == 1,
                                          expression: "showShaft==1",
                                        },
                                      ],
                                      attrs: {
                                        placement: "top",
                                        trigger: "hover",
                                        "close-delay": 0,
                                      },
                                      model: {
                                        value: i.openKuang,
                                        callback: function ($$v) {
                                          _vm.$set(i, "openKuang", $$v)
                                        },
                                        expression: "i.openKuang",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "text-align": "right",
                                            margin: "0",
                                          },
                                        },
                                        [
                                          ind != 0
                                            ? _c("el-button", {
                                                attrs: {
                                                  type: "success",
                                                  icon: "el-icon-back",
                                                  circle: "",
                                                  size: "mini",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.changeCitySort(
                                                      i,
                                                      item.cityList[ind - 1],
                                                      item
                                                    )
                                                  },
                                                },
                                              })
                                            : _vm._e(),
                                          ind != item.cityList.length - 1
                                            ? _c("el-button", {
                                                attrs: {
                                                  type: "warning",
                                                  icon: "el-icon-right",
                                                  circle: "",
                                                  size: "mini",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.changeCitySort(
                                                      item.cityList[ind + 1],
                                                      i,
                                                      item
                                                    )
                                                  },
                                                },
                                              })
                                            : _vm._e(),
                                          _c("el-button", {
                                            attrs: {
                                              type: "warning",
                                              icon: "el-icon-delete",
                                              circle: "",
                                              size: "mini",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.delPlanCity(
                                                  i,
                                                  ind,
                                                  item.cityList,
                                                  item
                                                )
                                              },
                                            },
                                          }),
                                          _c("el-button", {
                                            attrs: {
                                              type: "warning",
                                              icon: "el-icon-edit",
                                              circle: "",
                                              size: "mini",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.updateCityName(
                                                  i,
                                                  item
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            cursor: "pointer",
                                            "font-size": "0.16rem",
                                            "font-weight": "bold",
                                          },
                                          attrs: { slot: "reference" },
                                          slot: "reference",
                                        },
                                        [_vm._v(_vm._s(i.cityName))]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.showShaft == 2,
                                          expression: "showShaft==2",
                                        },
                                      ],
                                      staticStyle: {
                                        "font-size": "0.16rem",
                                        "font-weight": "bold",
                                        "margin-bottom": "0.1rem",
                                      },
                                    },
                                    [_vm._v(_vm._s(i.cityName))]
                                  ),
                                  _c(
                                    "el-popover",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.showShaft == 1,
                                          expression: "showShaft==1",
                                        },
                                      ],
                                      attrs: {
                                        placement: "top",
                                        trigger: "hover",
                                        "close-delay": 0,
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "text-align": "center",
                                            margin: "0",
                                          },
                                        },
                                        [
                                          _c("img", {
                                            staticStyle: {
                                              width: "26px",
                                              height: "20px",
                                            },
                                            attrs: {
                                              src: require("@/assets/svg/car.svg"),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.changeTrafficType(
                                                  i,
                                                  1
                                                )
                                              },
                                            },
                                          }),
                                          _c("img", {
                                            staticStyle: {
                                              width: "26px",
                                              height: "20px",
                                            },
                                            attrs: {
                                              src: require("@/assets/svg/ship.svg"),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.changeTrafficType(
                                                  i,
                                                  4
                                                )
                                              },
                                            },
                                          }),
                                          _c("img", {
                                            staticStyle: {
                                              width: "26px",
                                              height: "20px",
                                            },
                                            attrs: {
                                              src: require("@/assets/svg/train.svg"),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.changeTrafficType(
                                                  i,
                                                  3
                                                )
                                              },
                                            },
                                          }),
                                          _c("img", {
                                            staticStyle: {
                                              width: "26px",
                                              height: "20px",
                                            },
                                            attrs: {
                                              src: require("@/assets/svg/air.svg"),
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.changeTrafficType(
                                                  i,
                                                  2
                                                )
                                              },
                                            },
                                          }),
                                        ]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: { cursor: "pointer" },
                                          attrs: { slot: "reference" },
                                          slot: "reference",
                                        },
                                        [
                                          ind != item.cityList.length - 1
                                            ? _c("img", {
                                                staticStyle: {
                                                  width: "0.1rem",
                                                  height: "0.1rem",
                                                  margin:
                                                    "0.05rem 0.05rem 0 0.05rem",
                                                },
                                                attrs: {
                                                  src: require("@/assets/svg/" +
                                                    (i.trafficType == 2
                                                      ? "air.svg"
                                                      : i.trafficType == 3
                                                      ? "train.svg"
                                                      : i.trafficType == 4
                                                      ? "ship.svg"
                                                      : "car.svg")),
                                                  alt: "",
                                                },
                                              })
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          }),
                        ],
                        2
                      )
                    : _vm._e(),
                  _c(
                    "b",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showShaft == 1 && !item.inputShowState,
                          expression: "showShaft==1&&!item.inputShowState",
                        },
                      ],
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.addCity(item, index)
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-plus" }),
                      _vm._v("增加城市 "),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: item.inputShowState,
                          expression: "item.inputShowState",
                        },
                      ],
                      staticStyle: { "margin-bottom": "0.1rem" },
                      style: item.inputShowState ? "margin-top:0.1rem" : "",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                        },
                      },
                    },
                    [
                      _c("city-autocomplete", {
                        ref: "cityAutocomplete" + index,
                        refInFor: true,
                        attrs: { obj: _vm.city, action: false },
                        on: {
                          handleSelect: function ($event) {
                            return _vm.handleSelect($event, item)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c("p", [_vm._v("城市间驾车距离：无")]),
                ]),
                _c(
                  "div",
                  { staticClass: "oprateCityDiv" },
                  [
                    _c(
                      "el-tooltip",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showShaft == 1,
                            expression: "showShaft==1",
                          },
                        ],
                        staticClass: "item",
                        attrs: {
                          effect: "dark",
                          content: "插入前一天",
                          placement: "right",
                        },
                      },
                      [
                        _c(
                          "p",
                          {
                            style:
                              item.planDay == _vm.checkPlanDay
                                ? "background:#fff"
                                : "",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.updatePlanDay(1, item)
                              },
                            },
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: require("../../../assets/svg/moveup.svg"),
                                alt: "",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                    _c(
                      "el-tooltip",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showShaft == 1,
                            expression: "showShaft==1",
                          },
                        ],
                        staticClass: "item",
                        attrs: {
                          effect: "dark",
                          content: "插入后一天",
                          placement: "right",
                        },
                      },
                      [
                        _c(
                          "p",
                          {
                            style:
                              item.planDay == _vm.checkPlanDay
                                ? "background:#fff"
                                : "",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.updatePlanDay(2, item)
                              },
                            },
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: require("../../../assets/svg/movedown.svg"),
                                alt: "",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                    _c(
                      "el-tooltip",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showShaft == 1,
                            expression: "showShaft==1",
                          },
                        ],
                        staticClass: "item",
                        attrs: {
                          effect: "dark",
                          content: "删除当天行程",
                          placement: "right",
                        },
                      },
                      [
                        _c(
                          "p",
                          {
                            style:
                              item.planDay == _vm.checkPlanDay
                                ? "background:#fff"
                                : "",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.deletePlanDay(item)
                              },
                            },
                          },
                          [
                            _c("img", {
                              staticStyle: { width: "70%", height: "70%" },
                              attrs: {
                                src: require("../../../assets/svg/del.svg"),
                                alt: "",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            )
          }),
          0
        ),
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "修改城市节点",
            visible: _vm.dialogVisible,
            width: "30%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("city-autocomplete", {
            attrs: {
              obj: _vm.city,
              action: false,
              sizeType: "medium",
              width: "margin-top:0.2rem",
            },
            on: { handleSelect: _vm.handleUpdateSelect },
          }),
          _c("p", { staticStyle: { "margin-top": "0.1rem" } }, [
            _c(
              "span",
              { staticStyle: { color: "#009900", "font-weight": "bold" } },
              [_vm._v(_vm._s(_vm.updateCityObj.cityName))]
            ),
            _c("span", [_vm._v(" 修改为 ")]),
            _c(
              "span",
              { staticStyle: { color: "#009900", "font-weight": "bold" } },
              [_vm._v(_vm._s(_vm.updateCityNewObj.cityName))]
            ),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.updateCityPost },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "deleteDayDialog",
          attrs: {
            title: "删除当天",
            visible: _vm.deleteDayDialog,
            width: "50%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.deleteDayDialog = $event
            },
          },
        },
        [
          _c(
            "p",
            [
              _vm.deleteDayItem.planDay == 1
                ? _c(
                    "el-radio",
                    {
                      attrs: { label: "1" },
                      model: {
                        value: _vm.deleteChoose,
                        callback: function ($$v) {
                          _vm.deleteChoose = $$v
                        },
                        expression: "deleteChoose",
                      },
                    },
                    [_vm._v("删除该日期 及该日期内的所有城市及产品和说明")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "p",
            [
              _c(
                "el-radio",
                {
                  attrs: { label: "2" },
                  model: {
                    value: _vm.deleteChoose,
                    callback: function ($$v) {
                      _vm.deleteChoose = $$v
                    },
                    expression: "deleteChoose",
                  },
                },
                [
                  _vm._v(
                    "删除该日期内所有城市及产品和说明，且将之后所有行程和产品和说明前挪一天（注意部分产会因使用日期变动而失效） "
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "p",
            [
              _c(
                "el-radio",
                {
                  attrs: { label: "3" },
                  model: {
                    value: _vm.deleteChoose,
                    callback: function ($$v) {
                      _vm.deleteChoose = $$v
                    },
                    expression: "deleteChoose",
                  },
                },
                [_vm._v("保留日期，清空该日期内的所有城市及产品和说明")]
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.deleteDay } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }